import { render, staticRenderFns } from "./TemplateTypes.vue?vue&type=template&id=fba9bab2"
import script from "./TemplateTypes.vue?vue&type=script&lang=js"
export * from "./TemplateTypes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports